import { TaskType } from 'src/app/shared/enums';
import { Router } from '@angular/router';
import { ITaskModel } from '../../../../../shared/interfaces/task-model.interface';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { SystemEventParentType } from 'src/app/shared/enums/system-event-parent-type';
import { IProcessEventMetadata, ISystemEvent } from 'src/app/shared/interfaces/system-event.interface';
import * as _ from 'lodash';
import { EventsStatComponentComponent } from '../../processes/sections/events-stat-component/events-stat-component.component';
import { SystemEventService } from '../../../services/system-event.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'app-job-process-details-view',
    templateUrl: './job-process-details-view.component.html',
    styleUrls: ['./job-process-details-view.component.scss']
})
export class JobProcessDetailsViewComponent implements OnInit {
    selectedTabIndex: number = 0;
    systemEventParentType = SystemEventParentType;
    eventsList: ISystemEvent<IProcessEventMetadata>[] = [];

    constructor(private router: Router, private readonly systemEventService: SystemEventService) {}

    @Input()
    public task: ITaskModel;

    @Input()
    public isStep: boolean;

    @ViewChild(EventsStatComponentComponent) eventsStatistic: EventsStatComponentComponent;

    get showDataSourceCategories(): boolean {
        return (
            [
                TaskType.SYNC_ZONING_CODE_SOLR_DATA,
                TaskType.REMOVE_ZONING_CODE_SOLR_DATA,
                TaskType.SYNC_ZC_PRS_JOB,
                TaskType.ZONING_CODE_INDEXING_WITH_CURSOR,
                TaskType.COLLECT_TILES_DATA,
                TaskType.CREATE_PRS_LIST_BY_STATUS_PROCESS,
                TaskType.CALCULATE_GROUP_IDS_WITH_UPDATED_PLACES_JOB
            ].indexOf(this.task.type) >= 0
        );
    }

    get showSaveRawIds(): boolean {
        return [TaskType.SYNC_ZC_PRS_JOB, TaskType.ZONING_CODE_INDEXING_WITH_CURSOR].indexOf(this.task.type) >= 0;
    }

    get hasSpecificComponents() {
        return this.task && (this.task.isCalcPRMultiThread || this.task.isRemoveZoningCodeJob);
    }

    ngOnInit(): void {
        this.getSystemEvents().subscribe();
    }

    deleteProcess(isDeleteProcess: boolean): void {
        if (isDeleteProcess) {
            this.router.navigate([`/instances/jobs`]);
        }
    }

    tabChanged(tabChangeEvent: MatTabChangeEvent): void {
        this.selectedTabIndex = tabChangeEvent.index;
    }

    updateEventsList(data: ISystemEvent<IProcessEventMetadata>[]) {
        if (_.isEmpty(data)) {
            return;
        }
        this.eventsList = data;
        if (this.eventsStatistic) {
            this.eventsStatistic.runUpdate();
        }
    }

    getSystemEvents(): Observable<void> {
        if (!this.task) {
            return of();
        }

        return this.systemEventService
            .getSystemEvents(this.task.state.toLocaleLowerCase(), this.task.id, SystemEventParentType.PROCESS)
            .pipe(
                map((data: ISystemEvent<IProcessEventMetadata>[]) => {
                    this.eventsList = data;
                })
            );
    }
}
